module.exports = __webpack_public_path__ + "img/car.6a7b309a.svg";